import mapProps from 'recompose/mapProps';
import setDisplayName from 'recompose/setDisplayName';

const logProps = (file, line) =>
  setDisplayName(`LogProps(${file}:${line})`)(
    mapProps(props => {

      console.log(`${file}:${line}`, props);
      return props;

    }),
  );

export default logProps;



// WEBPACK FOOTER //
// ./src/components/HOC/debugging/logProps.js